import {useParams} from 'react-router-dom'
import {HeaderTitle} from '../../../../common/HeaderTitle.jsx'
import {useSelector} from 'react-redux'
import {ListaSprawozdanProjektu} from '../../lib/parts/ListaSprawozdanProjektu.jsx'
import {useListaSprawozdan} from '../../../../../api/domain/sprawozdania/queries/useListaSprawozdan.jsx'

const ViewListaSprawozdan = () => {
    const {rejestrId} = useParams()
    const rola = useSelector((state) => state.user.role)

    const listaSprawozdan = useListaSprawozdan(rejestrId)

    return (
        <>
            <HeaderTitle
                home
                nav
                size={'fs-2'}
                breadcrumbLinks={[
                    {
                        label: 'Wszystkie projekty',
                        to: `/${rola}/rejestr/lista`,
                    },
                    {label: 'Lista sprawozdań'},
                ]}
                data={[['ID projektu', rejestrId]]}
                destination={`/${rola}/rejestr/lista`}
                title={'Lista sprawozdań projektu'}
            />
            <ListaSprawozdanProjektu
                rejestrId={rejestrId}
                listaPozycji={listaSprawozdan}
                loading={listaSprawozdan.isLoading}
                exportFileName={`sprawozdania_projekt_${rejestrId}`}
            />
        </>
    )
}

export default ViewListaSprawozdan
